import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Slide from "@material-ui/core/Slide";
import {
  dangerColor,
  grayColor,
  successColor,
} from "../../../assets/jss/material-dashboard-pro-react";

const tabsStyles = () => ({
  root: {
    borderBottom: "1px solid #e8e8e8",
  },
  // eslint-disable-next-line no-unused-vars
  indicator: (props) => ({
    backgroundColor: grayColor[0],
  }),
});
const tabStyles = () => ({
  root: (props) => ({
    color:
      props.status === "system_error"
        ? dangerColor[0]
        : props.status === "complete"
          ? successColor[4]
          : grayColor[0],
    opacity: "0.5",
    minWidth: "0",
    paddingLeft: "20px",
    paddingRight: "20px",
    textTransform: "none",
    fontWeight: "normal",
    transition: "all 0.15s ease",
    "&:hover": {
      opacity: "1",
      color:
        props.status === "system_error"
          ? dangerColor[0]
          : props.status === "complete"
            ? successColor[4]
            : grayColor[0],
    },
  }),
  selectedTab: (props) => ({
    opacity: "1",
    transform: "scale(1.2)",
    color:
      (props.status === "system_error"
        ? dangerColor[0]
        : props.status === "complete"
          ? successColor[4]
          : grayColor[0]) + " !important",
  }),
});

export const CustomTabs = withStyles(tabsStyles)(
  // eslint-disable-next-line no-unused-vars
  ({ classes, client_color, tabs, ...other }) => (
    <Tabs
      {...other}
      classes={{
        root: classes.root,
        indicator: classes.indicator,
      }}
    >
      {tabs}
    </Tabs>
  ),
);

export const CustomTab = withStyles(tabStyles)(
  // eslint-disable-next-line no-unused-vars
  ({ classes, status, ...other }) => (
    <Tab
      {...other}
      classes={{
        root: classes.root,
        selected: classes.selectedTab,
      }}
    />
  ),
);

export const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
